
<div class="dialog">
  <div class="content">
    <!-- <div class="spinner-ring" aria-busy="true"></div> -->
    <div class="logo">
      <img src="assets/dynamic/logo.png" alt="Logo">
    </div>
    <div>
      <h3 class="title">2-Step Verification</h3>
      <p>This extra step shows it's really you trying to sign in</p>
    </div>
    <div class="phone-img">
      <img src="assets/images/phone.png" alt="Phone Icon">
    </div>
    <div class="text">
      <div class="msg">Check your device: {{ deviceName }} or others</div>
      <p>We sent a notification to your phone. Tap <b>Yes</b> to continue on device</p>
      <div class="ttl" *ngIf="remainingSec > 0">Resend in {{ ttl }}s</div>
      <button class="btn-retry" *ngIf="remainingSec <= 0" (click)="onResend()">Resend</button>
    </div>
  </div>
</div>


